var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08325 11.8335L0.583252 14.2835V7.25016H3.08325V11.8335ZM7.24992 10.3002L5.94159 9.1835L4.74992 10.2835V3.91683H7.24992V10.3002ZM11.4166 8.91683L8.91658 11.4168V0.583496H11.4166V8.91683ZM13.7583 8.7585L12.2499 7.25016H16.4166V11.4168L14.9249 9.92516L8.91658 15.8835L6.02492 13.3668L2.87492 16.4168H0.583252L5.97492 11.1335L8.91658 13.6168",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarFinance);
export default __webpack_public_path__ + "static/media/navbar-finance.e7eb1600.svg";
export { ForwardRef as ReactComponent };